module.exports = {
  pad: function(number) {
    var r = String(number);
    if ( r.length === 1 ) {
        r = '0' + r;
    }
    return r;
  },
  sign: function(number) {
    return number < 0 ? '-' : '+'
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/math.js
// module id = 13
// module chunks = 1 3